import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import layoutReducer from '@layout/layout.slice';
import userReducer from '@/pages/login/slice';

export const store = configureStore({
  reducer: {
    layout: layoutReducer,
    user: userReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
